import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Config } from '../config/config';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  constructor(private http: HttpClient, private config: Config) { }

  //getting youtube videos
  // 'https://www.googleapis.com/youtube/v3/search?key=' + 
  // this.apiKey + '&channelId=' + channel + '&order=date&part=snippet &type=video,id&maxResults=' + maxResults
  // return this.http.get<T>(this.server.serverUrl + 'search/users?q=' + userName);
  // Search videos by name
  // https://www.googleapis.com/youtube/v3/search?part=snippet&maxResults=25&q=surfing&key=[YOUR_API_KEY] HTTP/1.1

  public getSearchVideo<T>(channelId: String, maxResults: String): Observable<T> {
    return this.http.get<T>(this.config.baseUrl + 'search?key=' + this.config.apiKey + '&channelId=' + channelId + '&order=date&part=snippet &type=video,id&maxResults=' + maxResults);
  }
  public getSearchVideobyKeyWord<T>(searchKey: String): Observable<T> {
    return this.http.get<T>(this.config.baseUrl + 'search?part=snippet&maxResults=25&' + 'q=' + searchKey + '&key=' + this.config.apiKey);
  }

}
